import { createActionFactory } from '../../../common/redux';

const { createAction } = createActionFactory('Common Entities => Winner => ');

const toggleLayout = createAction('toggle layout', (layout) => ({ layout }));

export default {
  toggleLayout,
};
